module.exports = __webpack_public_path__ + "img/snacks-icon.ad4ac870.svg";